module.exports = __webpack_public_path__ + "7b59465a6ea931dc162a55b37f394f6c.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/banner_frame_moderator_1.png
// module id = 184
// module chunks = 0